import type React from "react"
import { useMemo } from "react"
import { IntlProvider } from "react-intl"

type IntlProps = React.ComponentProps<typeof IntlProvider>
type BarebonesProps = Omit<IntlProps, "locale" | "messages">

type Messages = Record<string, Exclude<IntlProps["messages"], undefined>>

interface UseTranslateProviderProps extends BarebonesProps {
  locale: string
  messages: Messages
  onLocaleChange?(locale: string): void
}

export const UseTranslateProvider: React.FC<UseTranslateProviderProps> = ({
  children,

  locale,
  messages,
  onLocaleChange,

  ...intlConfig
}) => {
  return (
    <IntlProvider {...intlConfig} locale={locale} messages={messages[locale]}>
      {children}
    </IntlProvider>
  )
}
